export class InstallmentCalculator {
	settings: any;
	balance: any;

	constructor(portalSettings: any, balance: any) {
		this.settings = portalSettings;
		this.balance = balance;
	}

	singlePaymentAmount() {
		return this.balance;
	}

	twoPaymentAmount() {
		return this.balance / 2;
	}

	threePaymentAmount() {
		return this.balance / 3;
	}
}
